import { render, staticRenderFns } from "./ColumnTransactionStatusOnii.vue?vue&type=template&id=629ca28e&scoped=true"
import script from "./ColumnTransactionStatusOnii.vue?vue&type=script&lang=js"
export * from "./ColumnTransactionStatusOnii.vue?vue&type=script&lang=js"
import style0 from "./ColumnTransactionStatusOnii.vue?vue&type=style&index=0&id=629ca28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ca28e",
  null
  
)

export default component.exports